export function ceil(number, precision) {
    var multiplier = !!precision ? Math.pow(10, precision) : 1;
    return Math.ceil(number * multiplier) / multiplier;
}
//# sourceMappingURL=ceil.js.map